import * as React from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import Layout from "../../layouts/Layout";
import { withRouter, RouteComponentProps } from "react-router";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "auto",
      marginTop: 64,
    },
  });

type Props = WithStyles<typeof styles> & RouteComponentProps;

class SourceManualPage extends React.Component<Props> {
  render() {
    const { classes } = this.props;
    return (
      <Layout>
        <Header />
        <div className={classes.root}>
          <h1>Source Manual Page</h1>
        </div>
        <Footer />
      </Layout>
    );
  }
}

export default withStyles(styles)(withRouter(SourceManualPage));
